import { render, staticRenderFns } from "./MyGraph.vue?vue&type=template&id=2bbb056f&scoped=true&"
import script from "./MyGraph.vue?vue&type=script&lang=js&"
export * from "./MyGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbb056f",
  null
  
)

export default component.exports